import React, {Component} from 'react';
import './Rooms.css';
import { NavLink } from 'react-router-dom';
import "animate.css/animate.min.css";
import Grid from '../Grid-View/Grid-View';
import room1 from './pokoj 1.jpg';
import Content from '../Content/Content';


class Room extends Component {
    componentDidMount () {
      let pxes = 1800;
      document.querySelector(`.btn-nxt`).addEventListener('click', () => {
        pxes = pxes+600;
        console.log(pxes);
        document.querySelector('.car').style.transform = `translate (-${pxes}px, 0)`;
      })
    }
    render() {
        return (
        <Content>
          <div className="carcont">
            <div className="car">
              <img src={room1}/>
              <img src={room1}/>
              <img src={room1}/>
              <img src={room1}/>
            </div>
          </div>
          <button className="btn-nxt">next</button>
        </Content>
        );
      }
}

export default Room;


// WEBPACK FOOTER //
// ./src/Rooms/Room.js